/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Workout_Added_ToastInputs */

const en_us2_workout_added_toast = /** @type {(inputs: Workout_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is in today's workout`)
};

const pt_br2_workout_added_toast = /** @type {(inputs: Workout_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entrou no treino de hoje`)
};

const es_419_workout_added_toast = /** @type {(inputs: Workout_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} está en el entrenamiento de hoy`)
};

const pt_pt2_workout_added_toast = /** @type {(inputs: Workout_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entrou no treino de hoje`)
};

const fr_fr2_workout_added_toast = /** @type {(inputs: Workout_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} est dans la séance du jour`)
};

const de_de2_workout_added_toast = /** @type {(inputs: Workout_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist im heutigen Training`)
};

const it_it2_workout_added_toast = /** @type {(inputs: Workout_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} è nell'allenamento di oggi`)
};

/**
* | output |
* | --- |
* | "{name} is in today's workout" |
*
* @param {Workout_Added_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_added_toast = /** @type {((inputs: Workout_Added_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Added_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_added_toast(inputs)
	if (locale === "es-419") return es_419_workout_added_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_added_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_added_toast(inputs)
	if (locale === "de-DE") return de_de2_workout_added_toast(inputs)
	if (locale === "it-IT") return it_it2_workout_added_toast(inputs)
	return en_us2_workout_added_toast(inputs)
});
export { workout_added_toast as "workout.added_toast" }